import cn from 'classnames';
import {ImageProps} from 'material-ui-image/lib/components/Image/Image';
import * as React from 'react';
import Image from 'material-ui-image';
import './ImageItem.scss';
import {RendererProps} from '../Renderer';
import {getToken} from '../../../store/dataService';

export type ImageItemProps = {
  adornment?: React.ReactNode;
  className?: string;
  shouldIncludeToken?: boolean;
  onClick?: ImageProps['onClick'];
  url: string | undefined | null | File;
  width: number;
  height: number;
} & Pick<RendererProps, 'isBusy'>;

export const ImageItem = ({
  adornment,
  className,
  height,
  onClick,
  url = '',
  shouldIncludeToken = true,
  width,
  isBusy,
}: ImageItemProps) => {
  return (
    <>
      <div
        className={cn('fileviewer__image-item', className)}
        style={{width: `${width}px`, height: `${height}px`}}
        onClick={onClick}
      >
        {url && (
          <Image
            className="fileviewer__image-item_image"
            src={`${url instanceof File ? URL.createObjectURL(url) : url}${
              shouldIncludeToken ? `&authToken=${getToken()}` : ''
            }`}
            imageStyle={{width, height, objectFit: 'cover'}}
            color=""
            disableSpinner
            disableTransition
          />
        )}
      </div>
      {adornment}
    </>
  );
};
